import { render, staticRenderFns } from "./RirekishoBeautyEdit.vue?vue&type=template&id=01f848f6&scoped=true"
import script from "./RirekishoBeautyEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoBeautyEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoBeautyEdit.vue?vue&type=style&index=0&id=01f848f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f848f6",
  null
  
)

export default component.exports